import * as React from 'react';
import { useState } from 'react';

import { Button } from '@rmwc/button';
import '@rmwc/button/styles';

import { Dialog, DialogTitle, DialogContent, DialogActions, DialogButton } from '@rmwc/dialog';
import '@rmwc/dialog/styles';

import { FeatherIcon } from './feather_icon';

import { TextInput } from './form';
import { SiteOverviewData } from '../types';
import { useUpdateSite } from './backend';

export interface WebportalDialogProps {
  site: SiteOverviewData;
  done: () => void;
};

export const WebportalDialog: React.FC<WebportalDialogProps> = ({ site, done }) => {
  const [url, setUrl] = useState(site.webportal);
  const mutation = useUpdateSite();

  const accept = async () => {
    try {
      await mutation.mutateAsync({
        id: site.id,
        comment: `Setting Webprotal URL`,
        webportal: url,
      });

      done();
    } catch {
      alert("Unable to update backend");
    }
  };

  const disabled = mutation.isLoading;

  return <Dialog open={true} onClose={done}>
    <DialogTitle>Change Project Phase</DialogTitle>
    <DialogContent>
      <TextInput disabled={disabled} label="Webportal URL" value={url} update={setUrl} />
    </DialogContent>
    <DialogActions>
      <DialogButton disabled={disabled} action="cancel">Cancel</DialogButton>
      <DialogButton disabled={disabled} isDefaultAction onClick={accept}>Save</DialogButton>
    </DialogActions>
  </Dialog>;
};

export interface WebportalButtonProps {
  site: SiteOverviewData;
}

export const WebportalButton: React.FC<WebportalButtonProps> = ({ site }) => {
  const [visible, setVisible] = useState(false);

  const open = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(true);
  };

  const done = () => {
    setVisible(false);
  };

  const dialog = visible ? <WebportalDialog site={site} done={done} /> : null;

  return <>
    {dialog}
    <Button className="edit_button" onClick={open}>
      <FeatherIcon icon="edit-2" />
    </Button>
  </>;
};
